import React, { useEffect, useState } from 'react';
import { PickerModal } from 'mui-daterange-picker-plus/dist';
import type { DateRange } from 'mui-daterange-picker-plus/dist';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import SearchBox from './SearchBox';
import DateIcon from '../assets/img/icon_date.svg';
import { Image } from 'react-bootstrap';
import moment from 'moment';
import { DATE_FORMAT } from '../utils/Constant';

interface IKDateRangePicker {
  onApply: (sateRange: DateRange) => void;
  startDate?: Date;
  endDate?: Date;
}

const KDateRangePicker: React.FunctionComponent<IKDateRangePicker> = ({
  onApply,
  startDate = undefined,
  endDate = undefined,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const [value, setValue] = useState<string>('');
  const getFormatedValue = (dateRange: DateRange) => {
    return (
      moment(dateRange?.startDate || startDate).format(DATE_FORMAT.DD_MM_YYYY) +
      ' To ' +
      moment(dateRange?.endDate || endDate).format(DATE_FORMAT.DD_MM_YYYY)
    );
  };

  useEffect(() => {
    if (startDate && endDate) {
      setValue(getFormatedValue({ startDate: startDate, endDate: endDate }));
    } else setValue('');
  }, [startDate, endDate]);

  return (
    <>
      <SearchBox
        label="Date Range"
        placeHolder={`${DATE_FORMAT.DD_MM_YYYY} To ${DATE_FORMAT.DD_MM_YYYY}`}
        value={value}
        readOnly
        onClick={handleClick}
        onChange={() => {}}
        icon={<Image src={DateIcon}></Image>}
      />
      <PickerModal
        hideOutsideMonthDays={false}
        initialDateRange={{
          startDate: startDate,
          endDate: endDate,
        }}
        minDate={moment().subtract(365, 'days').toDate()}
        maxDate={moment().add(365, 'days').toDate()}
        customProps={{
          onSubmit: (range: DateRange) => {
            onApply(range);
            handleClose();
          },
          onCloseCallback: handleClose,
          RangeSeparatorIcons: {
            xs: ArrowCircleDownIcon,
            md: ArrowCircleRightIcon,
          },
        }}
        modalProps={{
          open,
          anchorEl,
          onClose: handleClose,
          slotProps: {
            paper: {
              sx: {
                borderRadius: '16px',
                boxShadow: 'rgba(0, 0, 0, 0.21) 0px 0px 4px',
              },
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      />
    </>
  );
};

export default KDateRangePicker;
